// extracted by mini-css-extract-plugin
export default {"global-loader":"GlobalLoader_global-loader__Ao2aq","spinner":"GlobalLoader_spinner__cDl9B","spin":"GlobalLoader_spin__Tk4JL"};